export const WEB_APP_URL = "https://web.shopbook.tech";
export const WEB_REGISTER_URL = `${WEB_APP_URL}/?mode=register`;
export const WEB_LOGIN_URL = `${WEB_APP_URL}/?mode=login`;
export const PUBLIC_API_URL = (process.env.REACT_APP_BACKEND_URL || "https://api.shopbook.tech").replace(/\/$/, "");

export const GOOGLE_PLAY_URL = (
  process.env.REACT_APP_GOOGLE_PLAY_URL ||
  "https://play.google.com/store/apps/details?id=com.softmax.shopbook&pcampaignid=web_share"
).trim();
export const APP_STORE_URL = (process.env.REACT_APP_APP_STORE_URL || "").trim();
export const APP_STORE_EXPECTED_AT = (
  process.env.REACT_APP_APP_STORE_EXPECTED_AT || "2026-11-10T00:00:00+01:00"
).trim();
export const MOBILE_STORE_LINKS_READY = Boolean(GOOGLE_PLAY_URL || APP_STORE_URL);
export const ANDROID_BETA_URL = "/contact?topic=mobile-beta&platform=android";
export const IOS_BETA_URL = "/contact?topic=mobile-beta&platform=ios";

export const CONTACT_EMAIL = "hello@shopbook.tech";
export const SUPPORT_EMAIL = "support@shopbook.tech";

export const PLANS = [
  {
    code: "solo",
    name: "Solo",
    priceMinor: 150000,
    usdPriceMinor: 300,
    maxBranches: 1,
    maxStaff: 1,
    maxProducts: 200,
    includedCredits: 20,
    description: "Essential tools for an owner-run shop.",
  },
  {
    code: "starter",
    name: "Starter",
    priceMinor: 300000,
    usdPriceMinor: 500,
    maxBranches: 1,
    maxStaff: 3,
    maxProducts: 1000,
    includedCredits: 50,
    description: "More room for a growing shop and its team.",
  },
  {
    code: "growth",
    name: "Growth",
    priceMinor: 500000,
    usdPriceMinor: 1000,
    maxBranches: 3,
    maxStaff: 8,
    maxProducts: 5000,
    includedCredits: 100,
    description: "Multi-branch control with deeper business insights.",
  },
  {
    code: "scale",
    name: "Scale",
    priceMinor: 1000000,
    usdPriceMinor: 2000,
    maxBranches: 10,
    maxStaff: 20,
    maxProducts: 20000,
    includedCredits: 250,
    description: "High-capacity operations for established retailers.",
  },
];

export function formatNaira(priceMinor) {
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 0,
  }).format(priceMinor / 100);
}

export function formatUsd(priceMinor) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(priceMinor / 100);
}
